























import { Component, Vue, Prop } from 'vue-property-decorator';
import DrawingToolbar from '../Toolbars/DrawingToolbar.vue';

@Component({
  components: {
    DrawingToolbar,
  },
})
export default class DrawingElement extends Vue {
  @Prop(String) path!: string;
  @Prop(String) viewBox!: string;
  @Prop(String) color!: string;
  @Prop(String) thickness!: string;
  @Prop(Boolean) selected!: boolean;

  mounted() {
    this.$parent.$parent.$emit('updateMoveableComponent', {
      keepRatio: true,
    });
  }
}
